import { useEffect /*, useRef*/ } from "react";
import OktaSignIn, { WidgetOptions } from "@okta/okta-signin-widget";
import { oidcConfig, oktaClient } from "../utilities/okta";
import { useDispatch } from "../hooks/redux";
import { setLoggedInThroughUI } from "../store/queue/actions";

import "@okta/okta-signin-widget/dist/css/okta-sign-in.min.css";

export default function LoginPage() {
  /*const widgetRef = useRef<HTMLDivElement>(null);*/
  //const dispatch = useDispatch();

  useEffect(() => {
    // Clear any previous transaction
    window.sessionStorage.removeItem("okta-auth-js");

    const { issuer, clientId, redirectUri, scopes } = oidcConfig;

    const widget = new OktaSignIn({
      baseUrl: issuer.split("/oauth2")[0],
      clientId,
      redirectUri,
      logo: "/img/airfirst_logo.png",
      features: {
        idpDiscovery: false,
        debug: true,
      },
      authParams: {
        pkce: true,
        issuer,
        scopes: ["openid", "profile", "email"],
        responseType: ["token", "id_token"],
      },
    });

    widget
      .showSignInToGetTokens({ el: "#sign-in-widget" })
      .then((tokens) => {
        console.log("Tokens received:", tokens);
      })
      .catch((err) => console.error("Widget error:", err));
    //dispatch(setLoggedInThroughUI(true));

    return () => widget.remove();
  }, []);

  return <div id="sign-in-widget" /*ref={widgetRef}*/ />;
}
